module.exports = __webpack_public_path__ + "img/tf3661_center_002.23daa887.png";